import { forwardRef } from 'react';
import type { SVGIconProps } from '../types';

/**
 * Microsoft 公式ブランドロゴ（フルカラーの 4 分割スクエア）。色は公式配色で固定し `color` は無視する。
 * @see https://learn.microsoft.com/ja-jp/entra/identity-platform/howto-add-branding-in-apps
 */
export const MicrosoftIcon = forwardRef<SVGSVGElement, SVGIconProps>(({
  size = 16,
  color: _color,
  ...props
}, ref) => <svg ref={ref} width={size} height={size} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#F25022" d="M23.7629 23.7627H0V0H23.7629V23.7627Z" />
      <path fill="#7FBA00" d="M50 23.7627H26.2373V0H50V23.7627Z" />
      <path fill="#00A4EF" d="M23.7623 50H0V26.2373H23.7623V50Z" />
      <path fill="#FFB900" d="M50 50H26.2373V26.2373H50V50Z" />
    </svg>);
MicrosoftIcon.displayName = 'MicrosoftIcon';